module.exports = __webpack_public_path__ + "static/media/benefits10.c8673fbf.jpg";